import {axios} from "@/utilites/api";
import Config from "@/common/config";

const apiCompanions = '/companions'

const getAllPartners = () => {
    return axios.get(Config.apiURL + apiCompanions + '/api/v1/partners')
}

const createdPartner = (parameters) => {
    return axios.post(Config.apiURL + apiCompanions + '/api/v1/partners', parameters)
}

const updatePartner = (parameters) => {
    return axios.put(Config.apiURL + apiCompanions + '/api/v1/partners', parameters)
}

const deletedPartner = (parameters) => {
    return axios.delete(Config.apiURL + apiCompanions + '/api/v1/partners/' + parameters.id, parameters)
}

export default {
    getAllPartners,
    createdPartner,
    updatePartner,
    deletedPartner
}